/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: sunbingqing
 * @LastEditTime: 2024-08-20 17:56:21
 * @Description:
 */
import $ from 'webpack-zepto';
import _ from 'underscore';
import '@/core/config';
import User from '../core/user';
import { Toast } from 'vant';
import Vue from 'vue';
Vue.use(Toast);

function request(method, url, params, option) {
  return new Promise(function(resolve, reject) {
    let serverPath = window.CONFIG.server;
    // 不是短信类型，属于public目录，没有Token 返回
    if (!option.tempToken && !option.contextPath && !option.msgIds && url.indexOf('public/') != -1 && !User.token()) {
      console.log('token不存在:'+url);
      return;
    }
    if (SERVER) {
      serverPath = SERVER;
    }
    url = serverPath + url;
    const { hash = '' } = window.location || {};
    const originPath = hash.includes('?') ? hash.split('?')[0] : hash;
    const headers = {
      originPath,
      appId: User.appId() || '',
      openId: User.openId() || '',
      userId: User.uid() || '',
      xmToken: User.token() || option.tempToken || '',
      p: 'wechat',
      v: 'v5.0.0',
      product: option.product || 'customer',
      userType: option.userType || 'C',
      tempToken: option.tempToken || '',
      xmKey: option.xmKey || '',
      contentType: option.contentType || 'application/json; charset=UTF-8',
    };
    if (sessionStorage.getItem('brandMiniapp')) {
      headers.tenantId = sessionStorage.getItem('brandTenantId') || sessionStorage.getItem('brandInstId');
      headers.tenantType = sessionStorage.getItem('brandTenantType') || sessionStorage.getItem('brandInstType') || 'INST';
    }
    const ajaxOptions = {
      data: params,
      type: method || 'POST',
      url,
      contentType: option.contentType || 'application/json; charset=UTF-8',
      timeout: 20000,
      headers,
      dataType: option.dataType || 'json',
      processData: option.processData || true,
      beforeSend(xhr, settings) {
        option.beforeSend && option.beforeSend(xhr);
      },
      success(res, status, xhr) {
        const rejectCode = [
          'LOGIN_OVERDUE',
          '10000',
          '10001',
          '10002',
          'RPC_FAIL',
          'ILLEGAL_ARGUMENT',
          'BASIC_INFO_ERROR',
          'SCHEDULE_HAS_REMOVE',
          'SCHEDULE_NONE_STUDENT',
          'NONE_PERMISSION_JOIN',
          'VERIFY_CODE_ERROR',
        ];
        if (res.success) {
          res.data = res.data || res.result;
          resolve(res);
        } else if (rejectCode.indexOf(res.code) > -1) {
          reject(res);
        } else {
          processRequestError(res, reject, option);
          reject(res);
        }
      },
      error(xhr, errorType, error) {
        if (xhr.status == 418) {
          window.location.href = 'https://www.xiaomai5.com/maintain.html';
        } else if (xhr.status == 401 || xhr.status == 403) {
          if (option.product === 'xiaomaiInsure') {
            User.loginInsure();
            return;
          }
          User.loginIn();
        } else {
          processHttpError(xhr, errorType, error);
          reject(xhr, errorType, error);
        }
      },
      complete(xhr, status) {},
    };

    if (option.contextPath) {
      ajaxOptions.headers['xm_tag'] = option.contextPath;
    }

    if (option.msgIds) {
      ajaxOptions.headers['xm_msg_ids'] = option.msgIds;
    }

    $.ajax(ajaxOptions);
  });
}

function processSuccessData(data) {
  if (!data) {
    return {};
  }
  if (data && typeof data === 'string') {
    return JSON.parse(data);
  }

  return data;
}

function processRequestError(res, reject, option) {
  if (option.reject) {
    reject(res);
  } else {
    // Vue.$wheatToast({
    //   message: res.message,
    //   position: 'middle',
    // });
    Toast(res.message);
  }
}

function processHttpError(xhr, errorType, error) {
  //TODO Process HTTP error for 404, 503, 403, 500
  let message = '';
  // if (xhr.status === 503) {
  //   window.router.replace({ name: 'system_update'});
  //   return
  //  }
  if (xhr.status === 404) {
    message = '404 网络错误 \n 请检查你的本地网络是否连接';
  } else if (xhr.status === 500) {
    try {
      message = JSON.parse(xhr.data).message || 'Oops! 500错误 \n 服务器异常';
    } catch (error) {
      message = 'Oops! 500错误 \n 服务器异常';
    }
  } else if (xhr.status === 0) {
    return;
  } else {
    message = JSON.parse(xhr.data).message;
  }
  // Vue.$wheatToast({
  //   message: message,
  //   position: 'middle',
  // });
  Toast(message);
}

class Axios {
  static post(url, params = {}, option = {}) {
    return request('post', url, JSON.stringify(params), option);
  }

  static get(url, params = {}, option = {}) {
    return request('get', url, JSON.stringify(params), option);
  }
  static Customer(url, params = {}, option = {}) {
    return this.post(`customer/${url}`, params, option);
  }
  static Zeus(url, params = {}, option = {}) {
    return this.post(`zeus/${url}`, params, option);
  }
  static Finance(url, params = {}, option = {}) {
    return this.post(`finance/${url}`, params, option);
  }
  static Sales(url, params = {}, option = {}) {
    return this.post(`sales/${url}`, params, option);
  }

  static Apollo(url, params = {}, option = {}) {
    return this.post(`apollo/${url}`, params, option);
  }
  static MFS(url, params = {}, option = {}) {
    return this.post(`mfs/${url}`, params, option);
  }
  static Business(url, params = {}, option = {}) {
    return this.post(`business/${url}`, params, option);
  }
}

window.axios = Axios;



// WEBPACK FOOTER //
// ./src/service/Axios.js